<template>
    <plugin-home-how-it-works-v2-base-item v-bind:item="item">
        <div class="plugin-home-how-it-works-item__image">
            <slot />
        </div>
    </plugin-home-how-it-works-v2-base-item>
</template>

<script>
export default {
    name: 'plugin-home-how-it-works-v2-item-map',
    props: {
        item: {
            type: Object,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-how-it-works-item {
    &__image {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        width: 100%;
        height: 100%;

        aspect-ratio: 1 / 1;

        iframe {
            width: 100%;
            max-width: 350px;
        }
    }
    @media @media-md-down {
        &__image {
            width: 100%;
            iframe {
                width: 100%;
            }
        }
    }
}
</style>
